import { useEffect } from 'react';
import { history } from './store';

const sendPageView = (pathname) => {
  if (window._env_?.REACT_APP_ENVIRONMENT === 'prod' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};

export default function AnalyticsTracks() {
  useEffect(() => {
    sendPageView(history.location.pathname + history.location.search);

    const unlisten = history.listen((location) => {
      sendPageView(location.pathname + location.search);
    });

    return unlisten;
  }, []);

  return null;
}
